export type DesktopControlBarVariant = 'default' | 'viverse-pro'
export type DesktopControlBarSurface = 'normal' | 'fullscreen'

export type ControlBarPresentation =
  | { kind: 'none' }
  | { kind: 'mobile' }
  | { kind: 'kids-mode' }
  | {
      kind: 'desktop'
      surface: DesktopControlBarSurface
      variant: DesktopControlBarVariant
    }

export type ControlBarPresentationOptions = {
  hasKidsModeQueryParam: boolean
  isEmbedded: boolean
  isFull3D: boolean
  isFullscreen: boolean
  isMobileApp: boolean
  isMobile: boolean
  isPreferredDevice: boolean
  isPremiumContent: boolean
  isStandaloneContent: boolean
  isVideoContent: boolean
  isViverseProOwner: boolean
}

export const resolveControlBarPresentation = ({
  hasKidsModeQueryParam,
  isEmbedded,
  isFull3D,
  isFullscreen,
  isMobileApp,
  isMobile,
  isPreferredDevice,
  isPremiumContent,
  isStandaloneContent,
  isVideoContent,
  isViverseProOwner,
}: ControlBarPresentationOptions): ControlBarPresentation => {
  // Conditions are evaluated top to bottom; the first match determines the presentation.
  if (
    !isStandaloneContent ||
    isEmbedded ||
    !isPreferredDevice ||
    isPremiumContent ||
    isVideoContent
  ) {
    return { kind: 'none' }
  }

  if (isMobileApp && isFull3D && hasKidsModeQueryParam) {
    return { kind: 'kids-mode' }
  }

  if (isMobile) {
    return isFull3D ? { kind: 'mobile' } : { kind: 'none' }
  }

  if (isFull3D) return { kind: 'none' }

  return {
    kind: 'desktop',
    surface: isFullscreen ? 'fullscreen' : 'normal',
    variant: isViverseProOwner ? 'viverse-pro' : 'default',
  }
}
